export function faqAccordion() {
	if(document.querySelectorAll('.faq-button').length > 0) {
		const accordionTitles = document.querySelectorAll('.faq-button');
		let accordionId = 1;
		accordionTitles.forEach((accordionTitle) => {
			accordionTitle.setAttribute('aria-expanded', 'false');
			accordionTitle.setAttribute('id', 'faq-accordion-control-' + accordionId);
			accordionTitle.setAttribute('aria-controls', 'faq-accordion-control-' + accordionId);
			accordionTitle.nextElementSibling.setAttribute('id', 'faq-accordion-control-' + accordionId);
			accordionTitle.nextElementSibling.setAttribute('aria-hidden', 'true');
			accordionId = accordionId + 1;
			accordionTitle.addEventListener('click', () => {
				if(accordionTitle.classList.contains('is-open')) {
				accordionTitle.classList.remove('is-open');
				accordionTitle.setAttribute('aria-expanded', 'false');
				accordionTitle.nextElementSibling.setAttribute('aria-hidden', 'true');
				} else {
				const accordionTitlesWithIsOpen = document.querySelectorAll('.is-open');
				accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
					accordionTitleWithIsOpen.classList.remove('is-open');
					accordionTitleWithIsOpen.setAttribute('aria-expanded', 'false');
					accordionTitleWithIsOpen.nextElementSibling.setAttribute('aria-hidden', 'true');

				});
				accordionTitle.classList.add('is-open');
				accordionTitle.setAttribute('aria-expanded', 'true');
				accordionTitle.nextElementSibling.setAttribute('aria-hidden', 'false');
				}
			});
		});
	}
}
